import {
  IChartListApiResponse,
  IChartSingleApiResponse,
  IDashboardAPIService
} from "src/api/General/API_DashboardService";
import { IAccountingInvoicesSearchParams } from "src/models/Accounting/AccountingReports.models";
import {
  setDashboardList,
  setDashboardToEdit,
} from "src/store/General/slices/dashboardSlice"


const getPurchaseSectionDashboards = (dispatch: any, searchParams?: IAccountingInvoicesSearchParams) => {
  return new Promise<IChartSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await IDashboardAPIService.getPurchaseSection(searchParams);
      if (response?.success) {
        dispatch(setDashboardList(response?.data));
      }else{
        dispatch(setDashboardList(null));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const getInventorySectionDashboards = (dispatch: any, searchParams?: IAccountingInvoicesSearchParams) => {
  return new Promise<IChartSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await IDashboardAPIService.getInventorySection(searchParams);
      if (response?.success) {
        dispatch(setDashboardList(response?.data));
      }else{
        dispatch(setDashboardList(null));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const getAccountSectionDashboards = (dispatch: any, searchParams?: IAccountingInvoicesSearchParams) => {
  return new Promise<IChartSingleApiResponse>(async (resolve, reject) => {
    try {
      const response = await IDashboardAPIService.getAccountSection(searchParams);
      if (response?.success) {
        dispatch(setDashboardList(response?.data));
      }else{
        dispatch(setDashboardList(null));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

export { getPurchaseSectionDashboards, getInventorySectionDashboards, getAccountSectionDashboards };
